import { useState } from 'react';
import { PAYPAL, paypalUrl, isPaypalConfigured } from '../config';
export default function UpgradePanel({ sourceW, sourceH, cappedW, cappedH, onUnlock }) {
    const [opened, setOpened] = useState(false);
    const configured = isPaypalConfigured();
    const wasCapped = cappedW < sourceW || cappedH < sourceH;
    return (<div className="upgrade">
      <h3>
        Get the HD cutout &mdash; ${PAYPAL.price}
      </h3>
      <p className="meta" style={{ margin: 0 }}>
        {wasCapped
            ? `Your free download is ${cappedW} x ${cappedH}. The original is ${sourceW} x ${sourceH}.`
            : `Sharper edges on the same ${sourceW} x ${sourceH} image.`}
      </p>

      <ul>
        <li>Full source resolution, no size cap</li>
        <li>Higher-accuracy model &mdash; noticeably better on hair and fine detail</li>
        <li>Edge cleanup that removes the colour fringe from the old background</li>
      </ul>

      {!configured && (<p className="warn">
          PayPal is not configured yet. Set <code>PAYPAL.handle</code> in{' '}
          <code>src/config.ts</code> to your PayPal.me username.
        </p>)}

      {!opened ? (<div className="row">
          <button className="primary" disabled={!configured} onClick={() => {
                window.open(paypalUrl(), '_blank', 'noopener,noreferrer');
                setOpened(true);
            }}>
            Pay ${PAYPAL.price} with PayPal
          </button>
          <button className="link" onClick={() => setOpened(true)}>
            I already paid
          </button>
        </div>) : (<div className="row">
          <button className="primary" onClick={onUnlock}>
            Unlock HD
          </button>
          <button className="link" onClick={() => setOpened(false)}>
            Back
          </button>
        </div>)}

      <p className="note">
        One-time payment, no account needed. HD stays unlocked in this browser.
      </p>
    </div>);
}
